import React from 'react';

const SearchError = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 1.50018C30.216 1.50018 38.5 9.78218 38.5 20.0002C38.5 30.2162 30.216 38.5002 20 38.5002C9.782 38.5002 1.5 30.2162 1.5 20.0002C1.5 9.78218 9.782 1.50018 20 1.50018Z"
        stroke="#D9D9D9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9902 11.6667V22.3334"
        stroke="#D9D9D9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.99 27.5922H20.01"
        stroke="#D9D9D9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SearchError;
